import { Box, Slider, SliderProps } from '@mui/material';
import { GridRenderEditCellParams, useGridApiContext } from '@mui/x-data-grid';
import { JSX } from 'react';

interface DataGridEditNumberSliderCellProps
  extends GridRenderEditCellParams,
    Pick<SliderProps, 'min' | 'max'> {}

/**
 * Edit cell for numeric values via slider
 */
const DataGridEditNumberSliderCell = ({
  id,
  value,
  field,
  min,
  max,
}: DataGridEditNumberSliderCellProps): JSX.Element => {
  const apiRef = useGridApiContext();

  const handleValueChange = (_: unknown, newValue: number | number[]): void => {
    apiRef.current.setEditCellValue({
      id,
      field,
      value: Array.isArray(newValue) ? newValue[0] : newValue,
    });
  };

  return (
    <Box className="flex items-end w-full h-full px-4">
      <Slider
        value={value}
        valueLabelDisplay="on"
        step={1}
        min={min}
        max={max}
        onChange={handleValueChange}
      />
    </Box>
  );
};

export default DataGridEditNumberSliderCell;
